import * as React from 'react';

const PinIcon = ({color = 'black', size = 24}) => (
    <svg
        width={size}
        height={size}
        viewBox="2 2 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14.636 3.91c.653-.436.98-.654 1.335-.618.356.035.633.312 1.188.867l2.682 2.682c.555.555.832.832.867 1.188s-.182.682-.617 1.335l-1.65 2.473c-.561.843-.842 1.264-1.066 1.714a8 8 0 0 0-.427 1.031c-.16.477-.26.974-.458 1.967l-.19.955-.002.006a1 1 0 0 1-1.547.625l-.005-.004-.027-.018a35 35 0 0 1-8.85-8.858l-.004-.006a1 1 0 0 1 .625-1.547l.006-.001.955-.191c.993-.199 1.49-.298 1.967-.458a8 8 0 0 0 1.03-.427c.45-.224.872-.505 1.715-1.067z"
            stroke={color}
            strokeWidth={2}
        />
        <path
            d="m5 19 4.5-4.5"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
        />
    </svg>
);
export default PinIcon;
